import React from "react";

import Users from "@uui/Users03";

import { Typography, useMediaQuery } from "@mui/material";

import CountChip from "@app/analytics/components/CountChip";
import theme from "@app/analytics/theme";
import { UserEventGroup } from "@app/analytics/types/eventGroupTypes";
import { pluralizePhrase } from "@app/common/utils";

import Stack, { Column, Row } from "@rui/Stack";
import { ClampedTypography, Img } from "@rui/styles";

interface UpcomingEventRowHeaderProps {
  event: UserEventGroup;
  platformLogo: string;
  content?: React.ReactNode;
}
const UpcomingEventRowHeader = ({
  event,
  platformLogo,
  content,
}: UpcomingEventRowHeaderProps) => {
  const isDesktopView = useMediaQuery(theme.breakpoints.up("sm"));
  return (
    <Row
      spacing={{ xxs: 2, sm: 1.5 }}
      variant="left"
      sx={{ alignItems: { xxs: "start", sm: "center" } }}
    >
      {platformLogo && (
        <Img
          src={platformLogo}
          sx={{
            height: "24px",
            width: "24px",
            borderRadius: (theme) => theme.corners.base,
            border: { xxs: "1px solid #E0E0E0", sm: "none" },
            padding: { xxs: "8px", sm: "0" },
            boxSizing: { xxs: "content-box", sm: "inherit" },
          }}
        />
      )}
      <Column>
        <Stack
          direction={isDesktopView ? "column" : "row"}
          sx={{ overflowX: "hidden", gap: { xxs: "8px", sm: "0" } }}
        >
          <ClampedTypography
            variant={isDesktopView ? "bodySecondaryReg" : "bodySecondaryMed"}
            noWrap
            maxLines={1}
            minWidth={isDesktopView ? 200 : undefined}
            title={event.title}
          >
            {event.title}
          </ClampedTypography>
          {event.numAttendees > 0 && isDesktopView ? (
            <Typography variant="labelReg" color="shades.neutral.500">
              {pluralizePhrase(event.numAttendees, "participant")}
            </Typography>
          ) : (
            <CountChip Icon={Users}>{event.numAttendees}</CountChip>
          )}
        </Stack>
        {content}
      </Column>
    </Row>
  );
};

export default UpcomingEventRowHeader;
